export default "__VITE_ASSET__DwAjTUi6__"